__webpack_require__.p = "https://bpmrat-uat.bpglobal.com/";